import type { ReactElement } from "react";
import { useState } from "react";
import type { LaborCostSection } from "@/pages/human-resources/time-management/business/analysis/LaborCostSection";
import { LaborCostDetailsSectionTotalRow } from "./LaborCostDetailsSectionTotalRow";
import IconChevronDownProper from "@/shared/components/generic/icons/IconChevronDownProper.tsx";
import IconChevronRightProper from "@/shared/components/generic/icons/IconChevronRightProper.tsx";
import { LaborCostDetailsEmpRow } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost-details/LaborCostDetailsEmpRow.tsx";
import "./LaborCostDetailsSection.scss";

interface Props {
  section: LaborCostSection;
}

export function LaborCostDetailsSection({ section }: Props): ReactElement {
  const [open, setOpen] = useState(true);

  return (
    <>
      <tr
        className="section-row"
        onClick={() => {
          setOpen((prev) => !prev);
        }}
      >
        <td className="cell-section-toggle">
          {open ?
            <IconChevronDownProper />
          : <IconChevronRightProper />}
        </td>
        <td className="cell-section-label" colSpan={6}>
          {section.sectionLabel}
        </td>
      </tr>
      {section.employees.map((emp) => (
        <LaborCostDetailsEmpRow key={emp.employeeId} emp={emp} open={open} />
      ))}
      <LaborCostDetailsSectionTotalRow section={section} hidden={!open} />
      <tr className="section-spacer" />
    </>
  );
}
